



























import ripple from "./ripple.vue";
import calendar from "./calendar.vue";
import popupDisplay from "./popupDisplay.vue";
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import moment,{ weekdays, Moment } from "moment";
import { setInterval } from "timers";
import { nextTick } from "process";


@Component({
    components: {
        ripple,
        popupDisplay,
        calendar
    }
})
export default class dateSelector extends Vue {
    @Prop({}) visible:boolean;
    @Prop({}) from:boolean;
    @Prop({}) to:boolean;
    @Prop({}) dark:boolean;
    @Prop({}) largerSpacing:boolean;
    @Prop({}) defaultDate:Date;
    @Prop({}) placeholder:string;

    defDate:string = null;

    mounted(){
        this.estDefDate();
    }

    @Watch('defaultDate')
    estDefDate(){
        if(!this.defaultDate) this.defDate = this.placeholder;
        else this.defDate = moment(this.defaultDate).format("ddd, DD/MM/YY");
    }

    openPopup(){
        this.$emit('opened');
    }

    closePopup(){
        this.$emit('closed');
    }

    calculateNextDay(start: number) {
        return moment(start).add(1,"day").toDate().getTime();
    }

    dateSelected(date){
        
        if(this.to){
            date = this.calculateNextDay(date) - 1000;
        }
        this.defDate = moment(date).format("ddd, DD/MM/YY")

        nextTick(() => {
            this.closePopup();
        })
        this.$emit("change", new Date(date))
    }

}

